module.exports = __webpack_public_path__ + "assets/images/edge1030-b49a4d2c86d86d7f210914a706ec66dd.jpg";